import { apiService } from './apiService';

export type ArrivalSource = 'seyir' | 'mobile' | 'fallback';
export type ArrivalState = 'no-location' | 'no-coordinates' | 'not-arrived' | 'arrived';

export interface ArrivalPoint {
  route_id: number | null;
  point_name: string;
  address: string;
  city: string;
  district: string;
  point_latitude: number | null;
  point_longitude: number | null;
  is_completed: boolean;
  distance_km: number | null;
  arrived: boolean;
  arrived_at: string | null;
  first_seen_at: string | null;
  last_seen_at: string | null;
  location_source: ArrivalSource;
  location_updated_at: string | null;
  vehicle_latitude: number | null;
  vehicle_longitude: number | null;
  current_state: ArrivalState;
}

export interface ArrivalTrackingShipment {
  shipment_id: number;
  shipment_no: string;
  transport_model: string;
  owner_type: 'own' | 'spot';
  plate: string;
  driver_id: string | null;
  driver_name: string;
  pickup_name: string;
  pickup_city: string;
  delivery_name: string;
  delivery_city: string;
  assigned_at: string | null;
  pickup_date: string | null;
  delivery_date: string | null;
  process_status: string;
  status: string;
  points: ArrivalPoint[];
}

export interface ArrivalTrackingData {
  settings: {
    geofenceKm: number;
    transitionDate: string;
    customerCutoffTime: string;
    depotCutoffTime: string;
  };
  generatedAt: string;
  rows: ArrivalTrackingShipment[];
}

export interface ArrivalHistoryRow {
  id: number;
  shipment_id: number;
  shipment_no: string;
  point_name: string;
  plate: string;
  driver_name: string;
  owner_type: string;
  location_source: string;
  distance_km: number | null;
  arrived_at: string | null;
  pickup_name: string;
  pickup_city: string;
  delivery_city: string;
}

export const arrivalTrackingService = {
  async getList() {
    return await apiService.get<ArrivalTrackingData>('/arrival-tracking', { timeoutMs: 120000 });
  },

  async getHistory(params?: { from?: string; to?: string; plate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.from) queryParams.append('from', params.from);
    if (params?.to) queryParams.append('to', params.to);
    if (params?.plate) queryParams.append('plate', params.plate);
    const query = queryParams.toString();
    return await apiService.get<ArrivalHistoryRow[]>(`/arrival-tracking/history${query ? `?${query}` : ''}`, { timeoutMs: 120000 });
  },
};
